import {Tag} from "bbcode-to-react";
import React from "react";

export class GotoTag extends Tag {
    toReact() {
        return (
            <a href={this.params.link || this.getContent(true)} rel="noopener noreferrer" target="_blank">{this.getContent(true)}</a>
        );
    }
}